import {ThreadsAppImpl as LegacyThreadsAppImpl} from './LegacyThreadsApp';
import {ThreadsAppImpl} from './ThreadsApp';

// Choose once per app lifetime. A flag change takes effect on the next mount;
// transferring live conversations between these ownership models is unsafe.
export function createThreadsApp(
  ...[
    config,
    profile,
    clientFetch,
    parentMessageBus,
    onClose,
    observability,
    withHistory = true,
  ]: ConstructorParameters<typeof ThreadsAppImpl>
) {
  const historyEnabled =
    withHistory &&
    profile.featureFlags.enableConversationsThreadsHistory === true;
  const initialProfile = {
    ...profile,
    featureFlags: {
      ...profile.featureFlags,
      enableConversationsThreadsHistory: historyEnabled,
    },
  };
  const App = historyEnabled ? ThreadsAppImpl : LegacyThreadsAppImpl;
  return new App(
    config,
    initialProfile,
    clientFetch,
    parentMessageBus,
    onClose,
    observability,
    historyEnabled,
  );
}
